import React from 'react';
import { clsx } from 'clsx';
import classes from './Header.module.css.js';
import { defaultSxProp } from '../utils/defaultSxProp.js';
import { jsx } from 'react/jsx-runtime';
import Box from '../Box/Box.js';

const Header = /*#__PURE__*/React.forwardRef(function Header({
  children,
  className,
  sx: sxProp = defaultSxProp,
  as = 'header',
  ...rest
}, forwardRef) {
  if (sxProp !== defaultSxProp || as !== 'header') {
    return /*#__PURE__*/jsx(Box, {
      as: as,
      sx: sxProp,
      ref: forwardRef,
      className: clsx(className, classes.Header),
      ...rest,
      children: children
    });
  }
  return /*#__PURE__*/jsx("header", {
    ref: forwardRef,
    className: clsx(className, classes.Header),
    ...rest,
    children: children
  });
});
Header.displayName = 'Header';
const HeaderItem = /*#__PURE__*/React.forwardRef(function HeaderItem({
  children,
  className,
  sx: sxProp = defaultSxProp,
  full,
  ...rest
}, forwardRef) {
  if (sxProp !== defaultSxProp) {
    return /*#__PURE__*/jsx(Box, {
      as: 'div',
      sx: sxProp,
      ref: forwardRef,
      className: clsx(className, classes.HeaderItem),
      "data-full": full,
      ...rest,
      children: children
    });
  }
  return /*#__PURE__*/jsx("div", {
    ref: forwardRef,
    className: clsx(className, classes.HeaderItem),
    "data-full": full,
    ...rest,
    children: children
  });
});
HeaderItem.displayName = 'Header.Item';
const HeaderLink = /*#__PURE__*/React.forwardRef(function HeaderLink({
  children,
  className,
  sx: sxProp = defaultSxProp,
  as = 'a',
  ...rest
}, forwardRef) {
  if (sxProp !== defaultSxProp || as !== 'a') {
    return /*#__PURE__*/jsx(Box, {
      as: as,
      sx: sxProp,
      ref: forwardRef,
      className: clsx(className, classes.HeaderLink),
      ...rest,
      children: children
    });
  }
  return /*#__PURE__*/jsx("a", {
    ref: forwardRef,
    className: clsx(className, classes.HeaderLink),
    ...rest,
    children: children
  });
});
HeaderLink.displayName = 'Header.Link';
var Header$1 = Object.assign(Header, {
  Link: HeaderLink,
  Item: HeaderItem
});

export { Header$1 as default };
